module.exports = __webpack_public_path__ + "fa4cab3e4ee1b865a975e5eb6ab70d03.svg";